import { memo } from 'react'

const IconSpotFill = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.99998 14.1667C8.27278 14.5857 8.27345 14.5853 8.27345 14.5853L8.2746 14.5845L8.27829 14.5821L8.29117 14.5736C8.30217 14.5663 8.31792 14.5558 8.33812 14.5421C8.37852 14.5148 8.43671 14.4749 8.51016 14.4231C8.65701 14.3195 8.86516 14.1682 9.1142 13.9745C9.61147 13.5878 10.2759 13.0293 10.9422 12.3425C12.2527 10.9916 13.6666 9.04641 13.6666 6.87883C13.6666 5.4042 13.0667 3.99244 12.0027 2.95343C10.9391 1.91481 9.49909 1.33337 7.99998 1.33337C6.50087 1.33337 5.06083 1.91481 3.99726 2.95343C2.93329 3.99244 2.33331 5.4042 2.33331 6.87883C2.33331 9.04641 3.74721 10.9916 5.05777 12.3425C5.72403 13.0293 6.38849 13.5878 6.88576 13.9745C7.1348 14.1682 7.34295 14.3195 7.4898 14.4231C7.56325 14.4749 7.62144 14.5148 7.66184 14.5421C7.68204 14.5558 7.69779 14.5663 7.70879 14.5736L7.72167 14.5821L7.72536 14.5845L7.72691 14.5856C7.89275 14.6935 8.10694 14.6937 8.27278 14.5857L7.99998 14.1667ZM7.72691 14.5856C7.72691 14.5856 7.72718 14.5857 7.99998 14.1667L7.72691 14.5856ZM9.99998 7.00004C9.99998 8.10461 9.10455 9.00004 7.99998 9.00004C6.89541 9.00004 5.99998 8.10461 5.99998 7.00004C5.99998 5.89547 6.89541 5.00004 7.99998 5.00004C9.10455 5.00004 9.99998 5.89547 9.99998 7.00004Z'
        fill={fill}
      />
    </svg>
  )
}

export default memo(IconSpotFill)
